
import { Endpoint, EndpointRoutes } from '../endpoint.interface';

export interface DashboardEndpointRoutes extends EndpointRoutes {
  dashboard: {
    toString: () => string;
  
    getNumberOfUnitsData: {
      toString: () => string;
    };
    getFinancedEquipmentData: {
      toString: () => string;
    };
    getAverageAgeEquipmentData: {
      toString: () => string;
    };
    getNewEquipmentOrders: {
      toString: () => string;
    };
  
  };
}
export interface DashboardEndpoint extends Endpoint {
  baseUrl: string;
  routes: DashboardEndpointRoutes;
}
